module.exports = __webpack_public_path__ + "media/app/assets/specializations/hunter/beast_mastery-a945417580f60075a01518445dfe356c.png";